module.exports = __webpack_public_path__ + "img/jijinh.60e278f7.png";